export const protonImpurities = [
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.46,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 2.455,
                to: 2.465,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.89,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.885,
                to: 1.8949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.05,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.045,
                to: 2.0549999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.95,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.945,
                to: 1.9549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.31,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.305,
                to: 7.3149999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.15,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.145,
                to: 1.1549999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.16,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 3.1550000000000002,
                to: 3.165,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.89,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.885,
                to: 7.895,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.57,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.565,
                to: 3.5749999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.44,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.435,
                to: 1.4449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.77,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.765,
                to: 3.775,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.51,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.505,
                to: 5.515,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0975000000000001,
                to: 1.1425,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.38,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.34875,
                to: 3.41125,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.43,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.4050000000000002,
                to: 3.455,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.53,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.505,
                to: 3.5549999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.275,
                to: 3.2849999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.91,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.905,
                to: 7.915,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.88,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.875,
                to: 2.885,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.76,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.755,
                to: 2.7649999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.56,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.555,
                to: 3.565,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.275,
                to: 3.2849999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.43,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.4250000000000003,
                to: 3.435,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.1,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.0775000000000001,
                to: 1.1225,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.51,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.47875,
                to: 3.54125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.3,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 3.295,
                to: 3.3049999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.94,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.935,
                to: 1.9449999999999998,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.04,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.00875,
                to: 4.07125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.19,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.1675,
                to: 1.2125,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.36,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.355,
                to: 5.365,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.48,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.475,
                to: 3.485,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.85,
                to: 0.91,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.27625,
                to: 1.30375,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.18,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.1750000000000003,
                to: 2.185,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.2650000000000001,
                to: 1.315,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.58,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.563125,
                to: 2.5968750000000003,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.55,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.545,
                to: 4.555,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.48,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.4750000000000005,
                to: 7.485,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.94,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 6.9350000000000005,
                to: 6.945,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.19,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.185,
                to: 0.195,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.27,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.265,
                to: 3.275,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.02,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 3.015,
                to: 3.025,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.31,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.305,
                to: 4.3149999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.31,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.2850000000000001,
                to: 1.335,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.87675,
                to: 0.92325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.33,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.27025,
                to: 1.38975,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.08,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0675000000000001,
                to: 1.0925,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.82,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.77,
                to: 3.8699999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.69,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.67325,
                to: 1.70675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.89,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.8725,
                to: 4.9075,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.99,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.96375,
                to: 5.01625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.79,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.765,
                to: 5.815,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.54,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.514999999999999,
                to: 8.565,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.25,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.225,
                to: 7.275,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.65,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.625,
                to: 7.675000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 9.96,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 9.955,
                to: 9.965000000000002,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.66,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.635,
                to: 6.6850000000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.02,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 5.994999999999999,
                to: 6.045,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.75,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.725,
                to: 2.775,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.59,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.5650000000000002,
                to: 1.615,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.11,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.105,
                to: 0.115,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.62,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.595,
                to: 3.645,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.79,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.7650000000000001,
                to: 1.815,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.31,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.305,
                to: 2.315,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.1,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 7.074999999999999,
                to: 7.125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.19,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.165,
                to: 7.215000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.97,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9475,
                to: 0.9924999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.46,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.42875,
                to: 2.49125,
            },
        ],
        nucleus: '1H',
        solvent: 'THF-d₈',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.52,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 1.5150000000000001,
                to: 1.525,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.06,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.055,
                to: 2.065,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.12,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.115,
                to: 2.125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.97,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.965,
                to: 1.9749999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.35,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.345,
                to: 7.3549999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.24,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.235,
                to: 1.2449999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.32,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.315,
                to: 7.325,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.585,
                to: 3.5949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.44,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.435,
                to: 1.4449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.76,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.755,
                to: 3.7649999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.33,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.325,
                to: 5.335,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.15,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1275,
                to: 1.1724999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.43,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.39875,
                to: 3.46125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.57,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.545,
                to: 3.5949999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.5,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.475,
                to: 3.525,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.33,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.325,
                to: 3.335,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.96,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.955,
                to: 7.965,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.91,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.9050000000000002,
                to: 2.915,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.82,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.815,
                to: 2.8249999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.65,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.645,
                to: 3.655,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.34,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.335,
                to: 3.3449999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.49,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.4850000000000003,
                to: 3.495,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.19,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.1675,
                to: 1.2125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.66,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.62875,
                to: 3.69125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.33,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.3250000000000002,
                to: 1.335,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.995,
                to: 2.005,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.08,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.04875,
                to: 4.11125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.23,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.2075,
                to: 1.2525,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.3950000000000005,
                to: 5.405,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.66,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.6550000000000002,
                to: 3.665,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.84,
                to: 0.9,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.27,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.25625,
                to: 1.28375,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.2,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.1950000000000003,
                to: 2.205,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.27,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.245,
                to: 1.295,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.6,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.583125,
                to: 2.6168750000000003,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.59,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.585,
                to: 4.595,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.63,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.625,
                to: 7.635,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.07,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.065,
                to: 7.075,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.21,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.205,
                to: 0.215,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.42,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.415,
                to: 3.425,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.09,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.0850000000000002,
                to: 1.095,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.31,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.305,
                to: 4.3149999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.3,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.2750000000000001,
                to: 1.325,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.87675,
                to: 0.92325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.32,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.26025,
                to: 1.37975,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.17,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1575,
                to: 1.1824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.97,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.9200000000000004,
                to: 4.0200000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.71,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.69325,
                to: 1.72675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.93,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9125,
                to: 4.9475,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.03,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.00375,
                to: 5.05625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.84,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.8149999999999995,
                to: 5.865,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.59,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.565,
                to: 8.615,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.28,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.255,
                to: 7.305000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.68,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.654999999999999,
                to: 7.705,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.69,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 8.684999999999999,
                to: 8.695,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.79,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.765,
                to: 6.815,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.19,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.165,
                to: 6.215000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.82,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.795,
                to: 2.8449999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.67,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.645,
                to: 1.6949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.09,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.08499999999999999,
                to: 0.095,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.69,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.665,
                to: 3.715,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.82,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.7950000000000002,
                to: 1.845,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.34,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.335,
                to: 2.3449999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.15,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 7.125,
                to: 7.175000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.24,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.215,
                to: 7.265000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.99,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9675,
                to: 1.0125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.48,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.44875,
                to: 2.51125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.56,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 1.5550000000000002,
                to: 1.565,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.095,
                to: 2.105,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.17,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.165,
                to: 2.175,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.095,
                to: 2.105,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.36,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.355,
                to: 7.365,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.2750000000000001,
                to: 1.285,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.26,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.255,
                to: 7.265,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.67,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.665,
                to: 3.675,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.43,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.425,
                to: 1.4349999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.73,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.725,
                to: 3.735,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.3,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.295,
                to: 5.305,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.21,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1875,
                to: 1.2325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.48,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.44875,
                to: 3.51125,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.65,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.625,
                to: 3.675,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.57,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.545,
                to: 3.5949999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.39,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.3850000000000002,
                to: 3.395,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.02,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 8.014999999999999,
                to: 8.025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.96,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.955,
                to: 2.965,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.88,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.875,
                to: 2.885,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.71,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.705,
                to: 3.715,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.4,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.395,
                to: 3.405,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.55,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.545,
                to: 3.5549999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.87,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.865,
                to: 0.875,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.25,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.2275,
                to: 1.2725,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.72,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.68875,
                to: 3.75125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.32,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.3150000000000002,
                to: 1.325,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.05,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 2.045,
                to: 2.0549999999999997,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.12,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.08875,
                to: 4.15125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.26,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.2375,
                to: 1.2825,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.3950000000000005,
                to: 5.405,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.76,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.755,
                to: 3.7649999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.84,
                to: 0.87,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.25,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.23625,
                to: 1.26375,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.24,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.2350000000000003,
                to: 2.245,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8575,
                to: 0.9025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.26,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.235,
                to: 1.285,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.65,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.6331249999999997,
                to: 2.666875,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.62,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.615,
                to: 4.625,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.67,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.665,
                to: 7.675,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.1,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.095,
                to: 7.1049999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.22,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.215,
                to: 0.225,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.49,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.4850000000000003,
                to: 3.495,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.09,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.0850000000000002,
                to: 1.095,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.33,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.325,
                to: 4.335,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8575,
                to: 0.9025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.27,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.245,
                to: 1.295,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.87675,
                to: 0.92325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.32,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.26025,
                to: 1.37975,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.22,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.2075,
                to: 1.2325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 4.04,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.99,
                to: 4.09,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.73,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.71325,
                to: 1.74675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.94,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9225,
                to: 4.9575000000000005,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.03,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.00375,
                to: 5.05625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.83,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.805,
                to: 5.855,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.62,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.594999999999999,
                to: 8.645,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.29,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.265,
                to: 7.315,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.68,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.654999999999999,
                to: 7.705,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.4,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 8.395,
                to: 8.405000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.83,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.805,
                to: 6.855,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.26,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.234999999999999,
                to: 6.285,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.87,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.845,
                to: 2.895,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.68,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.655,
                to: 1.7049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.76,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.735,
                to: 3.7849999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.85,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.8250000000000002,
                to: 1.875,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.36,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.355,
                to: 2.3649999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.17,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 7.145,
                to: 7.195,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.25,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.225,
                to: 7.275,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.03,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0075,
                to: 1.0525,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.53,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.49875,
                to: 2.56125,
            },
        ],
        nucleus: '1H',
        solvent: 'CDCl₃',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.43,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 0.425,
                to: 0.435,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.57,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.5650000000000002,
                to: 1.575,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.57,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.5650000000000002,
                to: 1.575,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.69,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 0.6849999999999999,
                to: 0.695,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.12,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.115,
                to: 7.125,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.03,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.0250000000000001,
                to: 1.035,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 0.58,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 0.575,
                to: 0.585,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.1,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 6.095,
                to: 6.1049999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.36,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.355,
                to: 3.3649999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.395,
                to: 1.4049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.91,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.9050000000000002,
                to: 2.915,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.32,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 4.315,
                to: 4.325,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.1,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0775000000000001,
                to: 1.1225,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.25,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.21875,
                to: 3.28125,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.43,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.4050000000000002,
                to: 3.455,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.31,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.285,
                to: 3.335,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.12,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.115,
                to: 3.125,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.57,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.565,
                to: 7.575,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.37,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.365,
                to: 2.375,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.96,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.33,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.325,
                to: 3.335,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.12,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.115,
                to: 3.125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.31,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.305,
                to: 3.315,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.81,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.805,
                to: 0.8150000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.97,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 0.9475,
                to: 0.9924999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.36,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.32875,
                to: 3.39125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 0.83,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 0.825,
                to: 0.835,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.69,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.685,
                to: 1.6949999999999998,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.87,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 3.83875,
                to: 3.90125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.94,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 0.9175,
                to: 0.9624999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.25,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.245,
                to: 5.255,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.36,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.355,
                to: 3.3649999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.89,
                to: 0.96,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.33,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.3162500000000001,
                to: 1.34375,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.095,
                to: 2.105,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8575,
                to: 0.9025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.22,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.195,
                to: 1.2449999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.095,
                to: 0.10500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.42,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.4031249999999997,
                to: 2.436875,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.5,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.495,
                to: 4.505,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.3,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.295,
                to: 7.305,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.86,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 6.855,
                to: 6.865,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.17,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.165,
                to: 0.17500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.03,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.025,
                to: 3.0349999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.01,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.005,
                to: 3.0149999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.87,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8475,
                to: 0.8925,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.25,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.225,
                to: 1.275,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.86675,
                to: 0.91325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.32,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.26025,
                to: 1.37975,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 0.95,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9375,
                to: 0.9624999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.65,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.6,
                to: 3.6999999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.55,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.53325,
                to: 1.56675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.92,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9025,
                to: 4.9375,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.98,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.95375,
                to: 5.0062500000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.7,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.675,
                to: 5.7250000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.47,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.445,
                to: 8.495000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.67,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.645,
                to: 6.695,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.99,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 6.965,
                to: 7.015000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.71,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 7.705,
                to: 7.715,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.43,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.404999999999999,
                to: 6.455,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.27,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.244999999999999,
                to: 6.295,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.54,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.515,
                to: 2.565,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.36,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.3350000000000002,
                to: 1.385,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.26,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.255,
                to: 0.265,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.54,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.515,
                to: 3.565,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.43,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.405,
                to: 1.4549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.11,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.105,
                to: 2.1149999999999998,
            },
            {
                signals: [],
                integration: 3,
                from: 6.96,
                to: 7.01,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.09,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.0649999999999995,
                to: 7.115,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.95,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9275,
                to: 0.9724999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.39,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.35875,
                to: 2.42125,
            },
        ],
        nucleus: '1H',
        solvent: 'toluene-d₈',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.4,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 0.395,
                to: 0.405,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.52,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.5150000000000001,
                to: 1.525,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.55,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.5450000000000002,
                to: 1.555,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.58,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 0.575,
                to: 0.585,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.15,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.1450000000000005,
                to: 7.155,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.05,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.0450000000000002,
                to: 1.055,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 0.63,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 0.625,
                to: 0.635,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.15,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 6.1450000000000005,
                to: 6.155,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.39,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.3850000000000002,
                to: 3.395,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.395,
                to: 1.4049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.9,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.895,
                to: 2.905,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.27,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 4.265,
                to: 4.2749999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.11,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0875000000000001,
                to: 1.1325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.26,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.22875,
                to: 3.29125,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.46,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.435,
                to: 3.485,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.34,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.315,
                to: 3.3649999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.11,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.105,
                to: 3.1149999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.63,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.625,
                to: 7.635,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.36,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.355,
                to: 2.3649999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.86,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.8550000000000002,
                to: 1.865,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.35,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.345,
                to: 3.355,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.12,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.115,
                to: 3.125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.33,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.325,
                to: 3.335,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.8,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.795,
                to: 0.805,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.96,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 0.9375,
                to: 0.9824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.34,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.30875,
                to: 3.37125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 0.5,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 0.495,
                to: 0.505,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.65,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.645,
                to: 1.6549999999999998,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.89,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 3.85875,
                to: 3.92125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.92,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 0.8975000000000001,
                to: 0.9425,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.25,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.245,
                to: 5.255,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.41,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.4050000000000002,
                to: 3.415,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.9,
                to: 0.98,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.32,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.3062500000000001,
                to: 1.33375,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.13,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.125,
                to: 2.135,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.24,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.215,
                to: 1.265,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.12,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.11499999999999999,
                to: 0.125,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.4,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.3831249999999997,
                to: 2.416875,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.47,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.465,
                to: 4.475,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.33,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.325,
                to: 7.335,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.9,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 6.8950000000000005,
                to: 6.905,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.16,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.155,
                to: 0.165,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.065,
                to: 3.0749999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.94,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.935,
                to: 2.945,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.87,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8475,
                to: 0.8925,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.23,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.205,
                to: 1.255,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.86,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.83675,
                to: 0.88325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.26,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.20025,
                to: 1.31975,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 0.95,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9375,
                to: 0.9624999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.67,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.62,
                to: 3.7199999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.55,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.53325,
                to: 1.56675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.95,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9325,
                to: 4.9675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.01,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.98375,
                to: 5.03625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.72,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.694999999999999,
                to: 5.745,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.53,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.504999999999999,
                to: 8.555,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.66,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.635,
                to: 6.6850000000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.98,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 6.955,
                to: 7.005000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.8,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 7.795,
                to: 7.805,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.48,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.455,
                to: 6.505000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.37,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.345,
                to: 6.3950000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.54,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.515,
                to: 2.565,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.33,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.3050000000000002,
                to: 1.355,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.29,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.285,
                to: 0.295,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.57,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.545,
                to: 3.5949999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.4,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.375,
                to: 1.4249999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.11,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.105,
                to: 2.1149999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.02,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 6.994999999999999,
                to: 7.045,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.13,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.1049999999999995,
                to: 7.155,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.96,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9375,
                to: 0.9824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.4,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.36875,
                to: 2.43125,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₆',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.03,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 1.0250000000000001,
                to: 1.035,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.76,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.7550000000000001,
                to: 1.765,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.77,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.7650000000000001,
                to: 1.775,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.21,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.205,
                to: 1.2149999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.2,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.195,
                to: 7.205,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.12,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.1150000000000002,
                to: 1.125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.3,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.2950000000000002,
                to: 1.305,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.74,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 6.735,
                to: 6.745,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.41,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.4050000000000002,
                to: 3.415,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.37,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.3650000000000002,
                to: 1.375,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.26,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.255,
                to: 3.2649999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.77,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 4.765,
                to: 4.7749999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.1,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0775000000000001,
                to: 1.1225,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.31,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.27875,
                to: 3.34125,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.49,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.4650000000000003,
                to: 3.515,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.37,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.345,
                to: 3.395,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.16,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.1550000000000002,
                to: 3.165,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.73,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.7250000000000005,
                to: 7.735,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.51,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.505,
                to: 2.5149999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.3,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.295,
                to: 2.3049999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.45,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.4450000000000003,
                to: 3.455,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.17,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.165,
                to: 3.175,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.37,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.365,
                to: 3.375,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.79,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.785,
                to: 0.795,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.06,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.0375,
                to: 1.0825,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.51,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.47875,
                to: 3.54125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.39,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.385,
                to: 1.3949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.78,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.7750000000000001,
                to: 1.785,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.96,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 3.92875,
                to: 3.99125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.04,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.0175,
                to: 1.0625,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.29,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.285,
                to: 5.295,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.58,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.575,
                to: 3.585,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.86,
                to: 0.92,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.3,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.2862500000000001,
                to: 1.31375,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.095,
                to: 2.105,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.85,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8275,
                to: 0.8724999999999999,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.19,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.165,
                to: 1.2149999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.095,
                to: 0.10500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.47,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.453125,
                to: 2.4868750000000004,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.49,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.485,
                to: 4.495,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.53,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.525,
                to: 7.535,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.01,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.005,
                to: 7.015,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.15,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.145,
                to: 0.155,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.25,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.245,
                to: 3.255,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.3,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 1.2950000000000002,
                to: 1.305,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.585,
                to: 3.5949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.84,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8175,
                to: 0.8624999999999999,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.23,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.205,
                to: 1.255,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.84,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.81675,
                to: 0.86325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.26,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.20025,
                to: 1.31975,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.04,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0275,
                to: 1.0525,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.82,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.77,
                to: 3.8699999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.58,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.56325,
                to: 1.5967500000000001,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.91,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.8925,
                to: 4.9275,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.98,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.95375,
                to: 5.0062500000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.72,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.694999999999999,
                to: 5.745,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.51,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.485,
                to: 8.535,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.9,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.875,
                to: 6.925000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.25,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.225,
                to: 7.275,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.61,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 8.604999999999999,
                to: 8.615,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.62,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.595,
                to: 6.6450000000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.27,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.244999999999999,
                to: 6.295,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.64,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.615,
                to: 2.665,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.43,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.405,
                to: 1.4549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.14,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.135,
                to: 0.14500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.565,
                to: 3.6149999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.55,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.5250000000000001,
                to: 1.575,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.16,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.1550000000000002,
                to: 2.165,
            },
            {
                signals: [],
                integration: 3,
                from: 7.01,
                to: 7.08,
                multiplicity: 'm',
            },
            {
                signals: [],
                integration: 2,
                from: 7.1,
                to: 7.17,
                multiplicity: 'm',
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.93,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9075000000000001,
                to: 0.9525,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.39,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.35875,
                to: 2.42125,
            },
        ],
        nucleus: '1H',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.84,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 2.835,
                to: 2.8449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.96,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.09,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.085,
                to: 2.0949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.05,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.045,
                to: 2.0549999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.36,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.355,
                to: 7.365,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.18,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.175,
                to: 1.1849999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.02,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 8.014999999999999,
                to: 8.025,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.585,
                to: 3.5949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.43,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.425,
                to: 1.4349999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.87,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.865,
                to: 3.875,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.63,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.625,
                to: 5.635,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.11,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0875000000000001,
                to: 1.1325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.41,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.37875,
                to: 3.44125,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.56,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.535,
                to: 3.585,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.47,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.4450000000000003,
                to: 3.495,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.275,
                to: 3.2849999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.96,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.955,
                to: 7.965,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.94,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.935,
                to: 2.945,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.78,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.775,
                to: 2.7849999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.585,
                to: 3.5949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.275,
                to: 3.2849999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.46,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.455,
                to: 3.465,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.83,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.825,
                to: 0.835,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.0975000000000001,
                to: 1.1425,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.57,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.53875,
                to: 3.60125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.39,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 3.3850000000000002,
                to: 3.395,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.97,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.965,
                to: 1.9749999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.05,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.01875,
                to: 4.08125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.2,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.1775,
                to: 1.2225,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.38,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.375,
                to: 5.385,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.275,
                to: 3.2849999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.9,
                        assignment: 'CH₃',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 0.875,
                to: 0.925,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.27625,
                to: 1.30375,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.17,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.165,
                to: 2.175,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8575,
                to: 0.9025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.28,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.2550000000000001,
                to: 1.305,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.59,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.5731249999999997,
                to: 2.606875,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.54,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.535,
                to: 4.545,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.62,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.615,
                to: 7.625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.04,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.035,
                to: 7.045,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.17,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.165,
                to: 0.17500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.31,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.305,
                to: 3.315,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.12,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 3.115,
                to: 3.125,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.43,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.425,
                to: 4.435,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8575,
                to: 0.9025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.27,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.245,
                to: 1.295,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.85675,
                to: 0.90325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.31,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.25025,
                to: 1.36975,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.1,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0875000000000001,
                to: 1.1125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.9,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.85,
                to: 3.9499999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.68,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.66325,
                to: 1.69675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.9,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.8825,
                to: 4.9175,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.97375,
                to: 5.02625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.81,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.784999999999999,
                to: 5.835,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.58,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.555,
                to: 8.605,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.35,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.324999999999999,
                to: 7.375,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.76,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.734999999999999,
                to: 7.785,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 10.02,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 10.014999999999999,
                to: 10.025,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.77,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.744999999999999,
                to: 6.795,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.07,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.045,
                to: 6.095000000000001,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.13,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.125,
                to: 0.135,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.63,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.605,
                to: 3.655,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.79,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.7650000000000001,
                to: 1.815,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.32,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.315,
                to: 2.3249999999999997,
            },
            {
                signals: [],
                integration: 3,
                from: 7.1,
                to: 7.2,
                multiplicity: 'm',
            },
            {
                signals: [],
                integration: 2,
                from: 7.1,
                to: 7.2,
                multiplicity: 'm',
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.96,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9375,
                to: 0.9824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.45,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.41875,
                to: 2.48125,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.33,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 3.325,
                to: 3.335,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.91,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.905,
                to: 1.9149999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.09,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.085,
                to: 2.0949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.065,
                to: 2.0749999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.37,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.365,
                to: 7.375,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.11,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.1050000000000002,
                to: 1.115,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 4.19,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 4.1850000000000005,
                to: 4.195,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.32,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 8.315,
                to: 8.325000000000001,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.51,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.505,
                to: 3.5149999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.395,
                to: 1.4049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.9,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.895,
                to: 3.905,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.76,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.755,
                to: 5.765,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.09,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0675000000000001,
                to: 1.1125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.38,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.34875,
                to: 3.41125,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.51,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.485,
                to: 3.5349999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.38,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.355,
                to: 3.405,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.24,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.2350000000000003,
                to: 3.245,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.95,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.945,
                to: 7.955,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.89,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.8850000000000002,
                to: 2.895,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.73,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.725,
                to: 2.735,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.57,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.565,
                to: 3.5749999999999997,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.24,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.2350000000000003,
                to: 3.245,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.43,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.4250000000000003,
                to: 3.435,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.82,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.815,
                to: 0.825,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.06,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.0375,
                to: 1.0825,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.44,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.40875,
                to: 3.47125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 4.63,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 4.625,
                to: 4.635,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.99,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.985,
                to: 1.9949999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.03,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 3.9987500000000002,
                to: 4.06125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.17,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.1475,
                to: 1.1925,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.41,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.405,
                to: 5.415,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.34,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.335,
                to: 3.3449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.82,
                to: 0.88,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.24,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.22625,
                to: 1.25375,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.14,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.1350000000000002,
                to: 2.145,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.86,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8375,
                to: 0.8825,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.25,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.225,
                to: 1.275,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.06,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.055,
                to: 0.065,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.53,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.5131249999999996,
                to: 2.546875,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.61,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.605,
                to: 4.615,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.63,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.625,
                to: 7.635,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.01,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.005,
                to: 7.015,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.2,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.195,
                to: 0.20500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.16,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.1550000000000002,
                to: 3.165,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 4.01,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 4.005,
                to: 4.015,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.42,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.415,
                to: 4.425,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.86,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8375,
                to: 0.8825,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.27,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.245,
                to: 1.295,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.87,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.84675,
                to: 0.89325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.29,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.23025,
                to: 1.34975,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.04,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0275,
                to: 1.0525,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.78,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.73,
                to: 3.8299999999999996,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.68,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.66325,
                to: 1.69675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.94,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9225,
                to: 4.9575000000000005,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.03,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.00375,
                to: 5.05625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.8,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.7749999999999995,
                to: 5.825,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.58,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.555,
                to: 8.605,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.39,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.364999999999999,
                to: 7.415,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.79,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.765,
                to: 7.815,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 10.75,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 10.745,
                to: 10.755,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.73,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.705,
                to: 6.755000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.01,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 5.984999999999999,
                to: 6.035,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.67,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.645,
                to: 2.695,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.55,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.5250000000000001,
                to: 1.575,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: -0.06,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: -0.065,
                to: -0.055,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.6,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.575,
                to: 3.625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.76,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.735,
                to: 1.785,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.3,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.295,
                to: 2.3049999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.18,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 7.154999999999999,
                to: 7.205,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.25,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.225,
                to: 7.275,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.93,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9075000000000001,
                to: 0.9525,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.43,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.39875,
                to: 2.46125,
            },
        ],
        nucleus: '1H',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.13,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 2.125,
                to: 2.135,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.96,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.08,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.075,
                to: 2.085,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.96,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.37,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.365,
                to: 7.375,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.16,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.155,
                to: 1.1649999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.18,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 2.1750000000000003,
                to: 2.185,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.58,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.575,
                to: 7.585,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.51,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.505,
                to: 3.5149999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.44,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.435,
                to: 1.4449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.81,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.805,
                to: 3.815,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.44,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.4350000000000005,
                to: 5.445,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0975000000000001,
                to: 1.1425,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.42,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.38875,
                to: 3.45125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.53,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.505,
                to: 3.5549999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.45,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.4250000000000003,
                to: 3.475,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.29,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.285,
                to: 3.295,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.92,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.915,
                to: 7.925,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.89,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.8850000000000002,
                to: 2.895,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.77,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.765,
                to: 2.775,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.6,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.595,
                to: 3.605,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.275,
                to: 3.2849999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.45,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.4450000000000003,
                to: 3.455,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.0975000000000001,
                to: 1.1425,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.54,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.50875,
                to: 3.57125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.47,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 2.4650000000000003,
                to: 2.475,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.97,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 1.965,
                to: 1.9749999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.06,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.02875,
                to: 4.09125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.2,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.1775,
                to: 1.2225,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.41,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.405,
                to: 5.415,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.51,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.505,
                to: 3.5149999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.19,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.185,
                to: 2.195,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.28,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.2550000000000001,
                to: 1.305,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.57,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.5531249999999996,
                to: 2.586875,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.57,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.565,
                to: 4.575,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.57,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.565,
                to: 7.575,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.01,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.005,
                to: 7.015,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.2,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.195,
                to: 0.20500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.275,
                to: 3.2849999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.16,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 2.1550000000000002,
                to: 2.165,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.31,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.305,
                to: 4.3149999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.89,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8675,
                to: 0.9125,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.2650000000000001,
                to: 1.315,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.87675,
                to: 0.92325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.33,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.27025,
                to: 1.38975,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.09,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0775000000000001,
                to: 1.1025,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.87,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.8200000000000003,
                to: 3.92,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.7,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.68325,
                to: 1.71675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.93,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9125,
                to: 4.9475,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.04,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.01375,
                to: 5.06625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.85,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.824999999999999,
                to: 5.875,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.57,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.545,
                to: 8.595,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.33,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.305,
                to: 7.355,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.73,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.705,
                to: 7.755000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 9.27,
                        assignment: 'NH',
                        multiplicity: 'br t',
                    },
                ],
                integration: 1,
                from: 9.264999999999999,
                to: 9.275,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.75,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.725,
                to: 6.775,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.1,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.074999999999999,
                to: 6.125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.75,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.725,
                to: 2.775,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.61,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.5850000000000002,
                to: 1.635,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.08,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.075,
                to: 0.085,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.64,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.615,
                to: 3.665,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.8,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.7750000000000001,
                to: 1.825,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.33,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.325,
                to: 2.335,
            },
            {
                signals: [],
                integration: 3,
                from: 7.1,
                to: 7.3,
                multiplicity: 'm',
            },
            {
                signals: [],
                integration: 2,
                from: 7.1,
                to: 7.3,
                multiplicity: 'm',
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.96,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9375,
                to: 0.9824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.45,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.41875,
                to: 2.48125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃CN',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.66,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 3.6550000000000002,
                to: 3.665,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.06,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.055,
                to: 2.065,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.19,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.185,
                to: 2.195,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.95,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.945,
                to: 1.9549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.36,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.355,
                to: 7.365,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.2750000000000001,
                to: 1.285,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.2,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 1,
                from: 2.1950000000000003,
                to: 2.205,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.33,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.325,
                to: 7.335,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.64,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.6350000000000002,
                to: 3.645,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.47,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.465,
                to: 1.4749999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.71,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.705,
                to: 3.715,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.24,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.235,
                to: 5.245,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.2,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1775,
                to: 1.2225,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.58,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.54875,
                to: 3.61125,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.67,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.645,
                to: 3.695,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.62,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.595,
                to: 3.645,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.41,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.4050000000000002,
                to: 3.415,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.86,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.855,
                to: 7.865,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.98,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.975,
                to: 2.985,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.88,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.875,
                to: 2.885,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.76,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.755,
                to: 3.7649999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.4,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.395,
                to: 3.405,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.61,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.605,
                to: 3.6149999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.22,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.1975,
                to: 1.2425,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.71,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.67875,
                to: 3.74125,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.03,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 2.025,
                to: 2.0349999999999997,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.14,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.10875,
                to: 4.17125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.26,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.2375,
                to: 1.2825,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.4,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.3950000000000005,
                to: 5.405,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.72,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.7150000000000003,
                to: 3.725,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.88,
                to: 0.94,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.33,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.3162500000000001,
                to: 1.34375,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.24,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.2350000000000003,
                to: 2.245,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.91,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8875000000000001,
                to: 0.9325,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.31,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.2850000000000001,
                to: 1.335,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.08,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.075,
                to: 0.085,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.63,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.6131249999999997,
                to: 2.646875,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.53,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.525,
                to: 4.535,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.61,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.605,
                to: 7.615,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.03,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.025,
                to: 7.035,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.18,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.175,
                to: 0.185,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.44,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.435,
                to: 3.445,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.275,
                to: 4.285,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8775000000000001,
                to: 0.9225,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.33,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.3050000000000002,
                to: 1.355,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.87675,
                to: 0.92325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.33,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.27025,
                to: 1.38975,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.2,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1875,
                to: 1.2125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 4.05,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 4,
                to: 4.1,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.7,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.68325,
                to: 1.71675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.93,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9125,
                to: 4.9475,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.03,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.00375,
                to: 5.05625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.87,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.845,
                to: 5.8950000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.45,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.424999999999999,
                to: 8.475,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.4,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.375,
                to: 7.425000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.82,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.795,
                to: 7.845000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.84,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.8149999999999995,
                to: 6.865,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.24,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.215,
                to: 6.265000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.11,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.085,
                to: 3.135,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.93,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.905,
                to: 1.9549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.16,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.155,
                to: 0.165,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.78,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.755,
                to: 3.8049999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.91,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.885,
                to: 1.9349999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.33,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.325,
                to: 2.335,
            },
            {
                signals: [],
                integration: 3,
                from: 7.1,
                to: 7.3,
                multiplicity: 'm',
            },
            {
                signals: [],
                integration: 2,
                from: 7.1,
                to: 7.3,
                multiplicity: 'm',
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.31,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.2875,
                to: 1.3325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.12,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.08875,
                to: 3.15125,
            },
        ],
        nucleus: '1H',
        solvent: 'TFE-d₃',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.87,
                        multiplicity: 's',
                        assignment: 'OH',
                    },
                ],
                integration: 2,
                from: 4.865,
                to: 4.875,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.99,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.985,
                to: 1.9949999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.15,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.145,
                to: 2.155,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.03,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.025,
                to: 2.0349999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.33,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 6,
                from: 7.325,
                to: 7.335,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.4,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.395,
                to: 1.4049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.9,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.8950000000000005,
                to: 7.905,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.64,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.6350000000000002,
                to: 3.645,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.45,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 12,
                from: 1.445,
                to: 1.4549999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.78,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.775,
                to: 3.7849999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.49,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 5.485,
                to: 5.495,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.18,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1575,
                to: 1.2025,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.49,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.45875,
                to: 3.52125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.61,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.585,
                to: 3.635,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.58,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.555,
                to: 3.605,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.35,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.345,
                to: 3.355,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.97,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.965,
                to: 7.975,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.99,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.9850000000000003,
                to: 2.995,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.86,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.855,
                to: 2.8649999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.66,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.6550000000000002,
                to: 3.665,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.35,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.345,
                to: 3.355,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.52,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.515,
                to: 3.525,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.19,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.1675,
                to: 1.2125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.6,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.56875,
                to: 3.63125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.01,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 2.005,
                to: 2.0149999999999997,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.09,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.05875,
                to: 4.12125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.24,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.2175,
                to: 1.2625,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.39,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.385,
                to: 5.395,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.59,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.585,
                to: 3.5949999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [
            {
                signals: [],
                integration: 6,
                from: 0.86,
                to: 0.93,
                multiplicity: 'm',
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        multiplicity: 'br s',
                        assignment: 'CH₂',
                    },
                ],
                integration: 10,
                from: 1.27625,
                to: 1.30375,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.19,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.185,
                to: 2.195,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8775000000000001,
                to: 0.9225,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 8,
                from: 1.2650000000000001,
                to: 1.315,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.07,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.065,
                to: 0.07500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.64,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.623125,
                to: 2.6568750000000003,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.56,
                        multiplicity: 's',
                        assignment: 'H₂',
                    },
                ],
                integration: 2,
                from: 4.555,
                to: 4.5649999999999995,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.67,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.665,
                to: 7.675,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.05,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.045,
                to: 7.055,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.2,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.195,
                to: 0.20500000000000002,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.34,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.335,
                to: 3.3449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.34,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.335,
                to: 4.345,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.9,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.8775000000000001,
                to: 0.9225,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.29,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 6,
                from: 1.2650000000000001,
                to: 1.315,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.91,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.88675,
                to: 0.93325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.34,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.28025,
                to: 1.39975,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.5,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.4875,
                to: 1.5125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 3.92,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.87,
                to: 3.9699999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.7,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.68325,
                to: 1.71675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.91,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.8925,
                to: 4.9275,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.01,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 4.98375,
                to: 5.03625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.82,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.795,
                to: 5.845000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.53,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.504999999999999,
                to: 8.555,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.44,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.415,
                to: 7.465000000000001,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.85,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.824999999999999,
                to: 7.875,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.72,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.694999999999999,
                to: 6.745,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.08,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.055,
                to: 6.105,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.8,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 2.775,
                to: 2.8249999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.72,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.695,
                to: 1.7449999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.1,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.095,
                to: 0.10500000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.71,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.685,
                to: 3.735,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.87,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.8450000000000002,
                to: 1.895,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.32,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.315,
                to: 2.3249999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.16,
                        assignment: 'CH(2,4,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 3,
                from: 7.135,
                to: 7.1850000000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.16,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.135,
                to: 7.1850000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.05,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.0275,
                to: 1.0725,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.58,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.54875,
                to: 2.61125,
            },
        ],
        nucleus: '1H',
        solvent: 'CD₃OD',
    },
    {
        names: ['water'],
        smiles: 'O',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.08,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.075,
                to: 2.085,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.22,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 2.2150000000000003,
                to: 2.225,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.06,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.055,
                to: 2.065,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 1.24,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 9,
                from: 1.235,
                to: 1.2449999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.8,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 24,
                from: 3.795,
                to: 3.8049999999999997,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.17,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1475,
                to: 1.1925,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.56,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.52875,
                to: 3.59125,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.67,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.645,
                to: 3.695,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.61,
                        assignment: 'CH₂',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.585,
                to: 3.635,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.37,
                        multiplicity: 's',
                        assignment: 'OCH₃',
                    },
                ],
                integration: 6,
                from: 3.365,
                to: 3.375,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.92,
                        multiplicity: 's',
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 7.915,
                to: 7.925,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.01,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.005,
                to: 3.0149999999999997,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 2.85,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 2.845,
                to: 2.855,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.75,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 8,
                from: 3.745,
                to: 3.755,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.37,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 3.365,
                to: 3.375,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 3.6,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.595,
                to: 3.605,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.82,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.815,
                to: 0.825,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.17,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.1475,
                to: 1.1925,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 3.65,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 3.61875,
                to: 3.68125,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 2.07,
                        multiplicity: 's',
                        assignment: 'CH₃CO',
                    },
                ],
                integration: 3,
                from: 2.065,
                to: 2.0749999999999997,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 4.14,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 2,
                from: 4.10875,
                to: 4.17125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.24,
                        assignment: 'CH₂CH₃',
                    },
                ],
                integration: 3,
                from: 1.2175,
                to: 1.2625,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 5.44,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 5.4350000000000005,
                to: 5.445,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.65,
                        multiplicity: 's',
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 3.645,
                to: 3.655,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['H greaseᶠ'],
        smiles: '',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.28,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 0.275,
                to: 0.28500000000000003,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 9.5,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 2.61,
                        assignment: 'CH₃',
                    },
                ],
                integration: 18,
                from: 2.5931249999999997,
                to: 2.626875,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['hydrogen'],
        smiles: '',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 7.78,
                        multiplicity: 's',
                        assignment: 'CH(2)',
                    },
                ],
                integration: 1,
                from: 7.775,
                to: 7.785,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.14,
                        multiplicity: 's',
                        assignment: 'CH(4,5)',
                    },
                ],
                integration: 2,
                from: 7.135,
                to: 7.145,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 0.18,
                        multiplicity: 's',
                        assignment: 'CH₄',
                    },
                ],
                integration: 4,
                from: 0.175,
                to: 0.185,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.34,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 3.335,
                to: 3.3449999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 4.4,
                        multiplicity: 's',
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 4.3950000000000005,
                to: 4.405,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.88,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.85675,
                to: 0.90325,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7.3,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 1.3,
                        assignment: 'CH₂',
                    },
                ],
                integration: 2,
                from: 1.24025,
                to: 1.35975,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 1.17,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 1.1575,
                to: 1.1824999999999999,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6,
                                multiplicity: 'sept',
                            },
                        ],
                        delta: 4.02,
                        assignment: 'CH',
                    },
                ],
                integration: 1,
                from: 3.9699999999999998,
                to: 4.069999999999999,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 6.4,
                                multiplicity: 'd',
                            },
                            {
                                coupling: 1.5,
                                multiplicity: 't',
                            },
                        ],
                        delta: 1.7,
                        assignment: 'CH₃',
                    },
                ],
                integration: 3,
                from: 1.68325,
                to: 1.71675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 10,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 4.95,
                        assignment: 'CH₂(1)',
                    },
                ],
                integration: 1,
                from: 4.9325,
                to: 4.9675,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 17,
                                multiplicity: 'd',
                            },
                        ],
                        delta: 5.06,
                        assignment: 'CH₂(2)',
                    },
                ],
                integration: 1,
                from: 5.0337499999999995,
                to: 5.08625,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 5.9,
                        assignment: 'CH',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 5.875,
                to: 5.925000000000001,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 8.52,
                        assignment: 'CH(2,6)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 8.495,
                to: 8.545,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.45,
                        assignment: 'CH(3,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 7.425,
                to: 7.4750000000000005,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 7.87,
                        assignment: 'CH(4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 1,
                from: 7.845,
                to: 7.8950000000000005,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 6.93,
                        assignment: 'CH(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.904999999999999,
                to: 6.955,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 6.26,
                        assignment: 'CH(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 2,
                from: 6.234999999999999,
                to: 6.285,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.07,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.045,
                to: 3.0949999999999998,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.87,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.8450000000000002,
                to: 1.895,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        js: [],
                        delta: 3.74,
                        assignment: 'CH₂(2,5)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 3.7150000000000003,
                to: 3.765,
            },
            {
                signals: [
                    {
                        js: [],
                        delta: 1.88,
                        assignment: 'CH₂(3,4)',
                        multiplicity: 'm',
                    },
                ],
                integration: 4,
                from: 1.855,
                to: 1.9049999999999998,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [],
        nucleus: '1H',
        solvent: 'D₂O',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 't',
                            },
                        ],
                        delta: 0.99,
                        assignment: 'CH₃',
                    },
                ],
                integration: 6,
                from: 0.9675,
                to: 1.0125,
            },
            {
                signals: [
                    {
                        js: [
                            {
                                coupling: 7,
                                multiplicity: 'q',
                            },
                        ],
                        delta: 2.57,
                        assignment: 'CH₂',
                    },
                ],
                integration: 4,
                from: 2.53875,
                to: 2.60125,
            },
        ],
        nucleus: '1H',
        solvent: 'D₂O',
    },
];
//# sourceMappingURL=protonImpurities.js.map